import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import AddressBookList from './AddressBookList';
import AddEditReferralProviderPopup from '../Patient/Referral/AddEditReferralProviderPopup';
import AddEditReferralFacilityPopup from '../Patient/Referral/AddEditReferralFacilityPopup';
import AddEditReferralInsurancePopup from '../Patient/Referral/AddEditReferralInsurancePopup';
import { TbStethoscope } from 'react-icons/tb';
import { BiClinic } from 'react-icons/bi';
import { FaShieldHeart } from 'react-icons/fa6';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { useDebounce } from '../../Utilities/Utilities';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import setUiMessage from '../../Utilities/Tostify';

function AddressBookPopup({
  onClose,
  type = 2,
  selectAny = false,
  onSelectAddress,
  fromType = 'referral',
}) {
  const { user } = useSelector((store) => store.auth);
  const [addBookData, setAddBookData] = useState([]);
  const [typeState, setTypeState] = useState(type);
  const [srchVal, setSrchVal] = useState('');
  const debouncedSrchVal = useDebounce(srchVal, 500);

  const [reload, setReload] = useState(false);
  const onReload = () => setReload(!reload);
  const [editPopup, setEditPopup] = useState({
    open: false,
    referringMasterId: '',
  });

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: '',
  });

  useEffect(() => {
    const loadAddressBook = async () => {
      // Logic to load address book data
      const response = await post('api/CommonTask/openAddresspopup', {
        searchStr: '',
        type: typeState,
        selectAny,
      });

      if (response.status === 200) {
        setAddBookData(response.data || []);
      }
    };
    loadAddressBook();
  }, [typeState, selectAny, reload]);

  const handleAddressSelect = (address) => {
    if (selectAny || type === typeState) {
      onSelectAddress(address, type);
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteDialog({
      open: true,
      id: id,
    });
  };

  const confirmDelete = async () => {
    try {
      const response = await post('api/CommonTask/deleteAddressBookRecord', {
        id: deleteDialog.id,
        type: typeState,
        userId: user?.id,
      });

      if (response.status === 200) {
        setUiMessage('suc', 'Successfully deleted the record.');
        onReload();
        setDeleteDialog({ open: false, id: '' });
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const srch = debouncedSrchVal?.toLowerCase() || '';

  let masterData = [];

  if (typeState === 2) {
    masterData = addBookData?.referringMaster || [];
  } else if (typeState === 3 || typeState === 5) {
    masterData = addBookData?.facilityMaster || [];
  } else if (typeState === 4) {
    masterData = addBookData?.insuranceMaster || [];
  }

  const addressBookDataList = masterData.filter((item) => {
    // For type 2 (Referring Provider), ensure Name or Clinic is present as per requirements
    if (typeState === 2) {
      if (
        !item?.doctor_first_name &&
        !item?.doctor_last_name &&
        !item?.clinic_name
      ) {
        return false;
      }
    }

    const matchesSearch =
      String(item?.nameLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.addressLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.email || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.fax || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_l || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_m || '')
        .toLowerCase()
        .includes(srch) ||
      // Specific fields for different categories
      (typeState === 2 &&
        (String(item?.doctor_first_name || '')
          .toLowerCase()
          .includes(srch) ||
          String(item?.doctor_last_name || '')
            .toLowerCase()
            .includes(srch) ||
          String(item?.clinic_name || '')
            .toLowerCase()
            .includes(srch))) ||
      ((typeState === 3 || typeState === 5) &&
        String(item?.facility_name || '')
          .toLowerCase()
          .includes(srch)) ||
      (typeState === 4 &&
        String(item?.insurance_company_name || '')
          .toLowerCase()
          .includes(srch));

    return matchesSearch;
  });

  return (
    <div>
      <div className="modalBackground">
        <div className="openAddressBook openAddressBookModify">
          <div class="popup-header mb-0 flex justify-between items-center border-0">
            <h3 class="fw-600 fs-md text-accent-forground">
              Recipients Address Book
            </h3>
            <span
              class="close-btn close-btn fs-xl text-gray-400 mt-0"
              onClick={onClose}
            >
              &times;
            </span>
          </div>
          <div className="addressBody mt-3">
            <div className="addressWrapper flex items-center border border-lightgray rounded-md mb-3">
              <img
                src="./images/search.svg"
                width={15}
                className="ml-2 opacity-60"
                alt=""
              />
              <input
                className="px-3 py-0 text-slate-600 addressInput flex-1 fs-13 form-control shadow-sm"
                type="text"
                id="addressBookSearh"
                name="addressBookSearh"
                placeholder="Search recipients..."
                clickbutton="address-book-search"
                onChange={(e) => setSrchVal(e.target.value)}
              />
              <span
                className="button new-button cursor-style-for-link hide"
                id="address-book-search"
              >
                &nbsp;
              </span>
              <span
                className="address-book-search-delete m-0 hide"
                id="address-book-search-delete"
                onClick={null}
                clickbutton="address-book-search"
              >
                X
              </span>
            </div>

            {/* if selected card 
            <div class="flex items-center justify-between p-2-5 rounded-lg addressSelection mb-4">
              <span class="fs-13 fw-500 text-accent-forground">1 recipient selected</span>
              <button class="btn-outline-lightgray text-accent-forground bg-white rounded-lg shadow-sm py-2-5">Clear Selection</button>
            </div>*/}
            {/* addressBodyRow */}
            <div class="grid grid-cols-12 gap-4 mb-3">
              <div Class="col-span-9 p-0">
                {(() => {
                  if (typeState === 2) {
                    return (
                      <AddressBookList
                        addressBookData={addressBookDataList}
                        type={typeState}
                        handleAddressSelect={handleAddressSelect}
                        editPopup={editPopup}
                        setEditPopup={setEditPopup}
                        onDelete={handleDeleteClick}
                      />
                    );
                  } else if (typeState === 3 || typeState === 5) {
                    return (
                      <AddressBookList
                        // addressBookData={addBookData?.facilityMaster || []}
                        addressBookData={addressBookDataList}
                        type={typeState}
                        selectAny={selectAny}
                        handleAddressSelect={handleAddressSelect}
                        editPopup={editPopup}
                        setEditPopup={setEditPopup}
                        onDelete={handleDeleteClick}
                      />
                    );
                  } else if (typeState === 4) {
                    return (
                      <AddressBookList
                        // addressBookData={addBookData?.insuranceMaster || []}
                        addressBookData={addressBookDataList}
                        type={typeState}
                        selectAny={selectAny}
                        editPopup={editPopup}
                        handleAddressSelect={handleAddressSelect}
                        setEditPopup={setEditPopup}
                        onDelete={handleDeleteClick}
                      />
                    );
                  }
                })()}
              </div>

              {/* addressBodyRight */}
              <div className="col-span-3 text-muted">
                <div
                  className={`bodyLeftAdd cursor-pointer flex items-center gap-2 p-3 ${
                    typeState === 2 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(2)}
                >
                  <TbStethoscope style={{ fontSize: '1.2rem' }} />
                  Referring Provider/Clinics
                </div>
                <div
                  className={`bodyLeftAdd cursor-pointer flex items-center gap-2 p-3 ${
                    typeState === 3 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(3)}
                >
                  <BiClinic style={{ fontSize: '1.2rem' }} />
                  Facilities
                </div>
                <div
                  className={`bodyLeftAdd cursor-pointer flex items-center gap-2 p-3 ${
                    typeState === 4 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(4)}
                >
                  <FaShieldHeart style={{ fontSize: '1.1rem' }} />
                  Insurance
                </div>
                <div
                  className={`bodyLeftAdd cursor-pointer flex items-center gap-2 p-3 ${
                    typeState === 5 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(5)}
                >
                  <MdOutlineMoreHoriz style={{ fontSize: '1.2rem' }} />
                  Others
                </div>
              </div>
            </div>
            <div className="flex justify-end items-center pt-4 border-t border-t-lightgray gap-2">
              <button
                className="btn-outline-lightgray text-accent-forground rounded-md"
                onClick={onClose}
              >
                Cancel
              </button>
              <button className="btn-primary rounded-md">Done</button>
            </div>
          </div>
        </div>
        {typeState === 2 && editPopup.open && (
          <AddEditReferralProviderPopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {(typeState === 3 || typeState === 5) && editPopup.open && (
          <AddEditReferralFacilityPopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {typeState === 4 && editPopup.open && (
          <AddEditReferralInsurancePopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {deleteDialog.open && (
          <ConfirmDialog
            title={`Confirm!`}
            bodytext={`Do you really want to delete this record?`}
            closeDialog={() =>
              setDeleteDialog({
                open: false,
                id: '',
              })
            }
            successDialog={confirmDelete}
          />
        )}
      </div>
    </div>
  );
}

export default AddressBookPopup;
